export const CORRECT_ANSWERS_IN_A_ROW_TO_LEARN = 3;
export const CORRECT_ANSWERS_IN_A_ROW_TO_LEARN_DIFFICULT = 5;
